export default {
  circle: 'circle',
  rounded: 'rounded',
  ellipse: 'ellipse'
};
